import React, { useEffect, useState, useContext, useCallback } from "react";
import ListSaveButton from "../../Components/ListSaveButton";
import { debounce } from "lodash"; // Make sure lodash is installed
import PageTabs from "../../Components/PageTabs";
import TemplateSettingApi from "../../../API/APIServices/TemplateSetting";
import MyContext from "../../MyContext";
import AlertBox from "../../Props/AlertBox";
import Loader from "../../Props/Loader";
import MasterReportDataTable from "../../Master/TableMaster/MasterReportDataTable";
import ReportTableButton from "../../Props/ReportTableButton";
import { Link } from "react-router-dom";
import ItemMaster from "../../Master/InvertoryMaster/ItemMaster";
import AccountMaster1 from "../../Master/AccountMaster/AccountMaster";
import ItemMasterApi from "../../../API/APIServices/ItemMaster";
import { useNavigate } from "react-router-dom";
import AccountApi from "../../../API/APIServices/Account";
import AccountGroupMaster from "../../Master/AccountMaster/AccountGroupMaster";
import ItemGroupMaster from "../../Master/InvertoryMaster/ItemGroupMaster";
import UnitMaster from "../../Master/InvertoryMaster/UnitMaster";
import AgentMaster from "../../Master/AccountMaster/AgentMaster";
import ItemGroup from "../../../API/APIServices/ItemGroup";
import AccountGroup from "../../../API/APIServices/AccountGroup";
import UnitMasterApi from "../../../API/APIServices/UnitMaster";
import Swal from "sweetalert2";
import Agent from "../../../API/APIServices/Agent";
import * as XLSX from "xlsx";
import BillTypeApi from "../../../API/APIServices/BillType";
import BillType from "../../Master/BillAndOther/BillType";
import getCaseInSensitiveFieldValueFromObject from "../../../Utils/GetCaseInsensitiveFieldValueFromObject";
import VoucherConfigurationAndOtherSettingController from "../../../API/APIServices/VoucherConfigurationAndOtherSettingController";
import Station from "../../../API/APIServices/Station";
import StationMaster from "../../Master/AccountMaster/StationMaster";
import AccountCategory from "../../../API/APIServices/AccountCategory";
import AccountCategoryMaster from "../../Master/AccountMaster/AccountCategoryMaster";
import TransportMaster from "../../Master/AccountMaster/TransportMaster";
import StateInfo from "../../../API/APIServices/StateInfo";
import {
  getTodayDateYMD, getYesterdayDateYMD, getThisWeekRangeYMD,
  getLast7DaysRangeYMD, getThisMonthRangeYMD, getPreviousMonthRangeYMD
} from "./MasterReportCommonUtils/Dates/Dates";

function MasterListReport(props) {
  const [columnvalue, setcolumnvalue] = useState({});
  const [ExcelData, setExcelData] = useState();
  const [DateFilterCustom, setDateFilterCustom] = useState("created On");
  const [selectedOptions2, setSelectedOptions2] = useState([0]);
  const {
    OpenAlertBoxDelete,
    alertBoxDelete,
    setAlertBoxDelete,
    Defaultfilter2,
    setDefaultfilter2,
    input1,
    input2,
    input3,
    input4,
    input5,
    input6,
    input7,
    input8,
    UserDetails,
  } = useContext(MyContext);

  const [DefaultFilter, setDefaultFilter] = useState({});
  const navigate = useNavigate();
  const [loading, setLoading] = useState(document.readyState !== "complete");
  const [data1, setData1] = useState([]);
  const [templateData, setTemplateData] = useState();
  const [columns, setColumns] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [totalValue, setTotalValue] = useState([]);
  const [finalresult, setfinalresult] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [calculatedTotals, setCalculatedTotals] = useState({});
  const [reportAttachTo, setReportAttachTo] = useState("");

  const [searchAnyText, setSearchAnyText] = useState(false);
  const [searchByDate, setSearchByDate] = useState(false);
  const [printButton, setPrintButton] = useState(false);
  const [excelButton, setExcelButton] = useState(false);
  const [searchByColumn, setSearchByColumn] = useState(false);
  const [rowWiseEdit, setRowWiseEdit] = useState(false);
  const [rowWisePrint, setRowWisePrint] = useState(false);
  const [rowWiseWhatsapp, setRowWiseWhatsapp] = useState(false);
  const [rowWiseDelete, setRowWiseDelete] = useState(false);
  const [shareButton, setShareButton] = useState(false);
  const [columnShowTotalValue, setColumnShowTotalValue] = useState(false);
  const [firmNameSelect, setFirmNameSelect] = useState(false);
  const [transactionType, setTransactionType] = useState(false);
  const [billSeries, setBillSeries] = useState(false);
  const [reportConfig, setReportConfig] = useState([]);
  const [navigateTo, setNavigateTo] = useState(0);
  const [masterId, setMasterId] = useState(0);
  const [universalSearch, setUniversalSearch] = useState("");
  const url = window.location.href;
  const [customStartDate, setCustomStartDate] = useState("");
  const [customEndDate, setCustomEndDate] = useState("");

  const [heading, setHeading] = useState("");
  const [queryData, setQueryData] = useState("");
  const [dynamicColNameState, setDynamicColNameState] = useState([]);
  const [commonFilter, setCommonFilter] = useState([]);
  const [dateRangeToShow, setDateRangeToShow] = useState({
    dateFrom: "", dateTo: "", nameOfDateFilterWhichSet: ""
  });

  useEffect(() => {

    const handleReadyStateChange = () => {
      if (document.readyState === "complete") {
        setLoading(false);
      }
    };

    if (document.readyState !== "complete") {
      document.addEventListener("readystatechange", handleReadyStateChange);
    }

    return () => {
      document.removeEventListener("readystatechange", handleReadyStateChange);
    };
  }, []);

  // Filter data based on search queries
  useEffect(() => {
    console.log(templateData);
  }, [templateData]);

  const [filtercondition, setfiltercondition] = useState([]);

  const GetcolName = (name, q) => {

    if (q === undefined) {
      q = queryData;
    }
    if (q ==
      "") {
      return "";
    }

    var slicedQuery = q.slice(
      q.toLocaleLowerCase().indexOf("select") + "select".length,
      q.toLocaleLowerCase().indexOf("from")
    );
    let arr = slicedQuery.split(",").map((item) => item.trim());
    var searchval =
      arr.find((item) => {
        if (name.toLowerCase() === "id") {
          let parts = item.split(".");
          let columnName = parts.length > 1 ? parts[1].trim() : parts[0].trim();
          return columnName.toLowerCase() === "id";
        } else {
          return item.toLowerCase().includes(name.toLowerCase());
        }
      }) || null;
    if (searchval) {
      searchval = searchval.replace(/\s+AS\s+.*/i, "").trim();
    }
    return searchval;
  };

  const debouncedHandleKeyDown = useCallback(
    debounce(async (e, filt) => {
      console.log(filt);
      const { name, value } = e.target;
      // if (
      //   ["1", "89", "45", "2", "3", "4"].includes(
      //     filt?.columnSelectBoxWithSaveBtn
      //   ) 
      // ) {
      //   return;
      // }

      if (
        !value &&
        e.key != "ArrowDown" &&
        e.key != "ArrowUp" &&
        e.key != "Enter"
      ) {
        setLoading(true);
        fetchDataTemp();


        const tempFilter = [];

        setfiltercondition(tempFilter);
        return;
      }

      let searchval;
      if (queryData) {
        searchval = GetcolName(name);
      }

      const tempFilter = [
        {
          fieldName: searchval,
          operatorName: "like",
          compareValue: value,
        }
      ];

      setfiltercondition(tempFilter);
    }, 500), // debounce time 500ms
    [templateData, reportAttachTo, queryData]
  );

  // Lightweight wrapper
  const handleKeyDown = (e, filt) => {
    debouncedHandleKeyDown(e, filt);
  };

  const handleAlphabetSelect = (alphabet) => {

    const get_name_feild_to_search = getNameFeildToSearch();

    if (get_name_feild_to_search) {
      let searchValName = GetcolName(get_name_feild_to_search);

      setfiltercondition((prev) => {
        const index = prev.findIndex(
          (item) =>
            item.fieldName === searchValName &&
            item.operatorName === "startswith"
        );

        if (index !== -1 && prev[index].compareValue === alphabet) {
          // Same filter exists, so remove it
          const updated = [...prev];
          updated.splice(index, 1);
          return updated;
        }

        const newItem = {
          fieldName: searchValName,
          operatorName: "startswith",
          compareValue: `${alphabet}`,
        };

        const newItem2 = {
          fieldName: templateData?.templateSettingDTO?.eF1,
          operatorName: "equal",
          compareValue: reportAttachTo,
        };


        if (index !== -1) {
          // Update existing item
          const updated = [...prev];
          updated[index] = newItem;

          return updated;
        } else {
          // Add new item
          return [...prev, newItem, newItem2];
        }
      });
    }
  };

  const fetchfilter = async () => {
    console.log("Calling the Fetch Filter ");


    const filterConditionToSend = [...filtercondition];


    try {

      const response = await TemplateSettingApi.getDatasetExecuteQueryFilter(
        queryData,
        filterConditionToSend,
        pagecount,
        PageNumber,
        templateData.templateSettingDTO.eF2,
        templateData.templateSettingDTO.reportType,
        commonFilter
      );
      console.log(response);
      setLoading(false);
      listReport(response.table);

      let TotalRecords = getCaseInSensitiveFieldValueFromObject("TotalRecords", response.table[0]) ?? 0;

      setTotalRecords(TotalRecords);
    } catch (error) {
      console.error("Error executing query:", error);
    }
  };

  const changeDoubleClickFilter = (row, url) => {
    try {
      ;
      console.log(`changefilter`, DefaultFilter);
      const keys = Object.keys(DefaultFilter);

      const filter = keys
        .map((item) => {
          if (!DefaultFilter[item].column1 || !DefaultFilter[item].column2) {
            return;
          }
          const findValue = row.cells.find(
            (fitem) => fitem.column.Header == DefaultFilter[item].column1
          );
          const isNumeric =
            !isNaN(findValue?.value) && !isNaN(parseFloat(findValue?.value));
          return {
            // fieldName: GetcolName(DefaultFilter[item]?.column2),
            fieldName: DefaultFilter[item]?.column2,
            operatorName: isNumeric ? "equal" : "like",
            // operatorName:  "like",
            compareValue: findValue?.value,
          };
        })
        .filter((item) => item != undefined);
      localStorage.setItem("filter", JSON.stringify(filter));
      console.log(`filter`, filter);
      // setDefaultfilter2(filter)
      window.location.replace(url);
    } catch (error) {
      console.log(error);
    }
  };

  const localdata = async () => {
    ;
    const savedFilter = localStorage.getItem("filter");
    if (savedFilter) {
      console.log(`come from localstorage`, JSON.parse(savedFilter));
      const DoubleclickFilter = JSON.parse(savedFilter);
      for (let index = 0; index < DoubleclickFilter.length; index++) {
        const item = DoubleclickFilter[index];
        const e = {
          key: "Enter",
          target: {
            name: item.fieldName,
            value: item.compareValue,
          },
        };

        const getinputHeader = document.getElementById(item.fieldName);
        if (getinputHeader) {
          getinputHeader.value = item.compareValue;
        }

        if (e.target.value != null) {
          await handleKeyDown(e);
        }
      }
    }
  };

  useEffect(() => {
    ;
    if (queryData && templateData && Object.keys(columnvalue) != 0) {
      localdata().then(() => {
        localStorage.removeItem("filter");
      });
    }
  }, [queryData, templateData, columnvalue]);

  useEffect(() => {
    console.log(`Defaultfilter2`, Defaultfilter2);
  }, [Defaultfilter2]);

  useEffect(() => {
    if (editData == null) {
      fetchfilter();
    }
  }, [filtercondition, reportAttachTo]);

  const handleKeyDownUniversal = async (e, filterdata) => {
    //;
    if (e.key === "Enter") {
      e.preventDefault();

      const { name, value } = e.target;
      console.log(filterdata);
      if (!value) {
        fetchDataTemp();
        return;
      }
      var searchval;

      try {
        const finalResults = [];

        for (let i = 0; i < filterdata.length; i++) {
          const item = filterdata[i];
          if (queryData) {
            searchval = GetcolName(item.accessor);
          }
          if (item.accessor.length === 0) {
            continue;
          }

          let filterData = [
            {
              fieldName: searchval,
              operatorName: "like",
              compareValue: value,
            }
          ];


          try {
            // Await the result of the API call
            console.log("Key Down Universal");

            const response =
              await TemplateSettingApi.getDatasetExecuteQueryFilter(
                queryData,
                filterData,
                pagecount,
                PageNumber,
                templateData.templateSettingDTO.eF2,
                templateData.templateSettingDTO.reportType,
                commonFilter
              );

            let TotalRecords = getCaseInSensitiveFieldValueFromObject("TotalRecords", response.table[0]) ?? 0;

            setTotalRecords(TotalRecords);
            // Collect the result
            finalResults.push(...response.table);
            console.log(response);
          } catch (apiError) {
            // Handle errors specific to the API call
            console.error("Error executing query for item:", apiError);
          }
        }

        // After the loop, log and process the final results
        console.log(finalResults);
        listReport(finalResults);
      } catch (error) {
        // Handle errors that occur outside of the loop
        console.error("Error executing query:", error);
      }
    }
  };

  // Update custom dates
  const handleCustomDateChange = async (e, filterData) => {

    const { id, value, textContent } = e.target;
    if (id === "start-date") {
      setCustomStartDate(value);
      return;
    } else if (id === "end-date") {
      setCustomEndDate(value);
      return;
    }

    // --------------------changes --------------------

    if (!value && !textContent) {
      fetchDataTemp();
      return;
    }

    if (!DateFilterCustom) {
      alert("Please Select Date Type");
      return;
    }

    if (textContent == "Apply") {
      if (!customStartDate) {
        alert("Please select start date!");
        return;
      }

      if (!customEndDate) {
        alert("Please select end date!");
        return;
      }

      const tempFilter = [
        {
          fieldName: updateFieldName(
            templateData?.templateSettingDTO?.eF1,
            DateFilterCustom
          ),
          operatorName: "between",
          compareValue: `${customStartDate},${customEndDate}`,
        }
      ];

      let tempCommonFilter = [...commonFilter];

      tempCommonFilter = tempCommonFilter.filter(item => item.operatorName != "between");

      tempCommonFilter.push(tempFilter[0]);

      setCommonFilter(tempCommonFilter);

      setDateRangeToShow({
        dateFrom: customStartDate, dateTo: customEndDate, nameOfDateFilterWhichSet: "Custom Date"
      });

      setLoading(true);

      try {
        const response = await TemplateSettingApi.getDatasetExecuteQueryFilter(
          queryData,
          [],
          pagecount,
          PageNumber,
          templateData.templateSettingDTO.eF2,
          templateData.templateSettingDTO.reportType,
          tempCommonFilter
        );
        console.log(response);
        listReport(response.table);

        let TotalRecords = getCaseInSensitiveFieldValueFromObject("TotalRecords", response.table[0]) ?? 0;

        setTotalRecords(TotalRecords);
      } catch (error) {
        console.error("Error executing query:", error);
      }

      setLoading(false);
      return;
    }

    let tempCommonFilter = [...commonFilter];

    tempCommonFilter = tempCommonFilter.filter(item => item.operatorName != "between");

    let startDate = "", endDate = "";

    if (textContent == "Today") {

      const formattedDate = getTodayDateYMD();

      console.log(formattedDate);

      startDate = formattedDate;
      endDate = formattedDate;

    } else if (textContent == "Yesterday") {

      const formattedYesterday = getYesterdayDateYMD();

      console.log(formattedYesterday);

      startDate = formattedYesterday;
      endDate = formattedYesterday;

    } else if (textContent == "This Week") {

      const { startingDate, endingDate } = getThisWeekRangeYMD();

      startDate = startingDate;
      endDate = endingDate;

    } else if (textContent == "Last 7 Days") {

      const { startingDate, endingDate } = getLast7DaysRangeYMD();

      startDate = startingDate;
      endDate = endingDate;

    } else if (textContent == "This Month") {

      const { startingDate, endingDate } = getThisMonthRangeYMD();

      startDate = startingDate;
      endDate = endingDate;

    } else if (textContent == "Previous Month") {

      const { startingDate, endingDate } = getPreviousMonthRangeYMD();

      startDate = startingDate;
      endDate = endingDate;
    }



    if (textContent) {

      if (startDate !== "" && endDate !== "") {

        tempCommonFilter.push({

          fieldName: updateFieldName(
            templateData?.templateSettingDTO?.eF1,
            DateFilterCustom
          ),
          operatorName: "between",
          compareValue: `${startDate},${endDate}`,
        });

        setCommonFilter(tempCommonFilter);

        setDateRangeToShow({
          dateFrom: startDate, dateTo: endDate, nameOfDateFilterWhichSet: textContent
        });
      }


      setLoading(true);
      try {
        const response = await TemplateSettingApi.getDatasetExecuteQueryFilter(
          queryData,
          [],
          pagecount,
          PageNumber,
          templateData.templateSettingDTO.eF2,
          templateData.templateSettingDTO.reportType,
          tempCommonFilter
        );
        console.log(response);
        listReport(response.table);

        let TotalRecords = getCaseInSensitiveFieldValueFromObject("TotalRecords", response.table[0]) ?? 0;
        setTotalRecords(TotalRecords);
      } catch (error) {
        console.error("Error executing query:", error);
      }

      setLoading(false);
    }

    console.log(filterData);
  };

  // useEffect(() => {
  //   if (editData == null) {
  //     fetchDataTemp();
  //   }
  // }, [queryData]);

  useEffect(() => {
    if (queryData !== "") {
      fetchDataTemp();
    }
  }, [queryData]);

  useEffect(() => {
    fetchDataTemp();
  }, []);

  const [pagecount, setpagecount] = useState(1);

  const [
    rowwiseArrowforNavigationtoAnotherPage,
    setRowwiseArrowforNavigationtoAnotherPage,
  ] = useState(false);
  const [rowwiseButtontoOpenPopupWindow, setRowwiseButtontoOpenPopupWindow] =
    useState(false);
  const [useDoubleClick, setUseDoubleClick] = useState(false);

  function updateFieldName(fieldName, newSuffix) {

    if (!fieldName) {
      return newSuffix;
    }

    const lastDotIndex = fieldName.lastIndexOf(".");
    if (lastDotIndex > -1) {
      const baseName = fieldName.substring(0, lastDotIndex);
      return `${baseName}.${newSuffix}`;
    } else {
      return newSuffix;
    }
  }

  const [templateSettingDTOId, setTemplateSettingDTOId] = useState(0);

  function getNameFeildToSearch(col_list = []) {
    let colList =
      dynamicColNameState.length != 0 ? dynamicColNameState : col_list;

    for (let i = 0; i < colList.length; i++) {
      let isContainsName = colList[i].Header.toLowerCase().includes("name");
      if (isContainsName) {
        return colList[i].Header;
      }
    }

    return "";
  }

  const [dbColumnAndReportColumnNameMap, setDBColumnAndReportColumnNameMap] =
    useState({});

  const [showMainProductOnlyInItemSuggestion, setShowMainProductOnlyInItemSuggestion] = useState(false);

  useEffect(() => {

    console.log("showMainProductOnlyInItemSuggestion", showMainProductOnlyInItemSuggestion);
  }, [showMainProductOnlyInItemSuggestion]);

  async function fetchVoucherConfigurationAndOtherSettingController() {

    try {

      const filter = [
        {
          "fieldName": "masterSettName",
          "operatorName": "equal",
          "compareValue": "ShowMainProductOnlyInItemSuggestion"
        }
      ];

      const data = await VoucherConfigurationAndOtherSettingController.GetVoucherConfigurationAndOtherSettingController(filter);

      if (data?.isSuccess) {

        if (data?.result?.length === 0) {

          setShowMainProductOnlyInItemSuggestion(false);
          return false;
        }

        const lastIndex = data.result.length - 1;

        if (lastIndex >= 0) {
          const lastItem = data.result[lastIndex];

          const enableDisable = lastItem.enableDisable;
          setShowMainProductOnlyInItemSuggestion(enableDisable);

          return enableDisable;
        }
      }

      return false;

    } catch (error) {
      console.error("Error fetching voucher configuration:", error);
      return false;
    }

  }


  const fetchDataTemp = async () => {
    try {

      setLoading(true);

      const url = window.location.href;
      const id = url.split("?")[1];


      const filterData = [
        {
          fieldName: "reportAttachTo",
          operatorName: "Equal",
          compareValue: id,
        },
      ];
      const tempdata = await TemplateSettingApi.getTemplateSettingFilter(
        filterData
      );
      console.log(tempdata);
      // [1].templateSettingDTO.pagination

      // setTemplateList(tempdata);
      const FilterTempdata = tempdata.find(
        (item) => item.templateSettingDTO.reportType == 1
      );
      console.log(FilterTempdata.templateSettingDTO.pagination);
      var masterid = FilterTempdata.templateSettingDTO.id;
      setTemplateSettingDTOId(masterid);
      console.log(masterid);
      setpagecount(FilterTempdata.templateSettingDTO.pagination);
      setReportAttachTo(id);
      setLoading(false);

      const response = await TemplateSettingApi.getTemplateSettingById(
        masterid
      );
      // alert(id[1])
      console.log(id);
      console.log(response);

      //;

      setTemplateData(response);
      setQueryData(response.templateSettingDTO.queryForSql);
      setSearchAnyText(response.templateSettingDTO.search_AnyText);
      setSearchByDate(response.templateSettingDTO.search_ByDate);
      setPrintButton(response.templateSettingDTO.printButton);
      setExcelButton(response.templateSettingDTO.excelButton);
      setSearchByColumn(response.templateSettingDTO.search_ByColumn);
      setRowWiseEdit(response.templateSettingDTO.rowWise_Edit);
      setRowWisePrint(response.templateSettingDTO.rowWise_Print);
      setRowWiseWhatsapp(response.templateSettingDTO.rowWise_Whatsapp);
      setRowWiseDelete(response.templateSettingDTO.rowWise_Delete);
      setFirmNameSelect(response.templateSettingDTO.firmNameSelect);
      setTransactionType(response.templateSettingDTO.transactionTypeSelect);
      setBillSeries(response.templateSettingDTO.billSeriesNameSelect);
      setRowwiseArrowforNavigationtoAnotherPage(
        response.templateSettingDTO.rowWise_ArrowForOtherPage
      );
      setNavigateTo(response.templateSettingDTO.eF3);
      setUseDoubleClick(response.templateSettingDTO.srch1);
      setRowwiseButtontoOpenPopupWindow(
        response.templateSettingDTO.rowWise_TransporterOrOther
      );

      const tempCommonFilter = [];


      if (response?.templateSettingDTO?.eF1) {

        tempCommonFilter.push({
          fieldName: response?.templateSettingDTO?.eF1,
          operatorName: "equal",
          compareValue: id,
        });
      }


      tempCommonFilter.push({
        fieldName: updateFieldName(response?.templateSettingDTO?.eF1, "IsDeleted"),
        operatorName: "equal",
        compareValue: 0,
      });



      /* show only parent product start*/

      let showOnlyParentProduct = false;
      if (id == 4) {

        // const Lens_SPH = GetcolName("Lens_SPH", response.templateSettingDTO.queryForSql);
        // const Lens_CYL = GetcolName("Lens_CYL", response.templateSettingDTO.queryForSql);

        showOnlyParentProduct = await fetchVoucherConfigurationAndOtherSettingController();


        if (showOnlyParentProduct) {


          const Lens_EYE = updateFieldName(response?.templateSettingDTO?.eF1, "Lens_EYE");
          const modifiedLens_EYE = `ISNUll(${Lens_EYE}, '')`;

          tempCommonFilter.push({
            fieldName: modifiedLens_EYE,
              operatorName: "notequal",
              compareValue: 'RL',
          });

          tempCommonFilter.push({
            fieldName: modifiedLens_EYE,
              operatorName: "notequal",
              compareValue: 'R',
          });

          tempCommonFilter.push({
            fieldName: modifiedLens_EYE,
              operatorName: "notequal",
              compareValue: 'L',
          });
        }


      }

      setCommonFilter(tempCommonFilter);

      /* show only parent product end*/


      if (response.templateSettingDTO.eF4) {
        const decode = decodeURIComponent(response.templateSettingDTO.eF4);
        const parse = JSON.parse(decode);
        console.log("JSON PARSE", parse);
        setDefaultFilter(parse);
      }
      const defaultColumns = [
        { Header: <input type="checkbox" />, accessor: "input" },
        { Header: "SNO", accessor: "sno" },
      ];

      const dynamicColumns = Array.isArray(
        response.templateSettingReportConfigList
      )
        ? response.templateSettingReportConfigList
            .filter((column) => column.showOrHide)
            .map((column) => ({
              Header:
                column.columnNameByUser.trim() !== ""
                  ? column.columnNameByUser
                  : column.columnName,
              accessor: column.columnName.toLowerCase(),
              priority: parseInt(column.col1, 10) || 0,
            }))
        : [];

      setDynamicColNameState(dynamicColumns);

      const sortedDynamicColumns = dynamicColumns.sort(
        (a, b) => a.priority - b.priority
      );

      const length = response?.templateSettingReportConfigList
        ? response?.templateSettingReportConfigList.length
        : 0;

      const mapDict = {};

      for (let i = 0; i < length; i++) {
        const key =
          response?.templateSettingReportConfigList[
            i
          ].columnName.toLocaleLowerCase();

        const name = GetcolName(key);

        const nameArray = name ? name.split(".") : [""];

        const value = nameArray.length > 1 ? nameArray[1] : nameArray[0];
        mapDict[key] = value.toLocaleLowerCase();
      }

      setDBColumnAndReportColumnNameMap(mapDict);

      const combinedColumns = [
        ...defaultColumns,
        // ...dynamicColumns,
        ...sortedDynamicColumns,
        { Header: "ACTION", accessor: "action" },
      ];

      setColumns(combinedColumns);
      console.log(combinedColumns);

      const defaultFilterData = [
        { Header: "", accessor: "" },
        { Header: "", accessor: "" },
      ];
      //;
      const dynamicFilterData = Array.isArray(
        response.templateSettingReportConfigList
      )
        ? response.templateSettingReportConfigList
            .filter((column) => column.showOrHide)
            .map((filter, index) => ({
              Header: (
                <input
                  type="text"
                  name={filter.columnName}
                  id={`${filter.columnName}`}
                  placeholder={filter.columnNameByUser}
                  onKeyDown={(e) => handleKeyDown(e, filter)}
                />
              ),
              // accessor: filter.accessor || `dynamic_filter_${index}`,

              accessor:
                filter.columnName.toLowerCase() || `dynamic_filter_${index}`,
              priority: parseInt(filter.col1, 10) || 0,
            }))
        : [];

      const sortedDynamicFilterData = dynamicFilterData.sort(
        (a, b) => a.priority - b.priority
      );

      const combinedFilterData = [
        ...defaultFilterData,
        // ...dynamicFilterData,
        ...sortedDynamicFilterData,
      ];

      setFilterData(combinedFilterData);
      console.log(combinedFilterData);

      fetchData({
        rowWiseEdit1: response.templateSettingDTO.rowWise_Edit,
        rowWiseDelete1: response.templateSettingDTO.rowWise_Delete,
        rowWiseWhatsapp1: response.templateSettingDTO.rowWise_Whatsapp,
        rowWisePrint1: response.templateSettingDTO.rowWise_Print,
        queryData: response.templateSettingDTO.queryForSql,
        combinedTotalValue: response.templateSettingReportConfigList,
        ef1: response.templateSettingDTO.eF1,
        ef2: response.templateSettingDTO.eF2,
        reportType: response.templateSettingDTO.reportType,
        tempCommonFilter: tempCommonFilter
      });
      setReportConfig(response.templateSettingReportConfigList);

    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (reportConfig) {
      console.log("reportConfig", reportConfig);
      for (let index = 0; index < reportConfig.length; index++) {
        const item = reportConfig[index];
        setcolumnvalue((prev) => {
          return {
            ...prev,
            [item.columnName]: "",
          };
        });
      }
    }
  }, [reportConfig]);

  useEffect(() => {
    console.log(`columnvalue`, columnvalue);
  }, [columnvalue]);

  const [PageNumber, setPageNumber] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const fetchData = async (obj = {}) => {

    const { rowWiseEdit1, rowWiseDelete1, rowWiseWhatsapp1,
      rowWisePrint1, queryData, combinedTotalValue, ef1, ef2,
      reportType, tempCommonFilter = commonFilter } = obj;

    setLoading(true);

    const url = window.location.href;
    const reportAttachTo = url.split("?")[1];
    let filterData = [];
    // if (ef1?.toLowerCase().includes(".string")) {
    //   filterData = [
    //     {
    //       fieldName: updateFieldName(ef1, "isDeleted"),
    //       operatorName: "equal",
    //       compareValue: 0,
    //     },
    //   ];
    // } else {
    //   filterData = [
    //     {
    //       fieldName: ef1,
    //       operatorName: "equal",
    //       compareValue: reportAttachTo,
    //     },
    //     {
    //       fieldName: updateFieldName(ef1, "isDeleted"),
    //       operatorName: "equal",
    //       compareValue: 0,
    //     },
    //   ];
    // }

    let filterDataToSend = filterData;



    try {
      // let pagesize = 60
      console.log("Calling Inside FetchData");

      const val = await TemplateSettingApi.getDatasetExecuteQueryFilter(
        queryData,
        filterDataToSend,
        pagecount,
        PageNumber,
        ef2,
        reportType,
        tempCommonFilter
      );
      console.log(val);
      //;
      listReport(
        val.table,
        rowWiseEdit1,
        rowWiseDelete1,
        rowWiseWhatsapp1,
        rowWisePrint1,
        combinedTotalValue
      );

      let TotalRecords = getCaseInSensitiveFieldValueFromObject("TotalRecords", val.table[0]) ?? 0;

      setTotalRecords(TotalRecords);
    } catch (error) {
      console.log(error);
    }
  };

  const recall = async () => {
    //;
    console.log("Calling the Recall ");
    if (templateData == null) {
      return;
    }

    try {
      setLoading(true);
      const url = window.location.href;
      const reportAttachTo = url.split("?")[1];
      let filterData = [];

      let filterDataToSend = filterData;

      console.log(templateData);
      console.log("Calling Inside recall");
      const val = await TemplateSettingApi.getDatasetExecuteQueryFilter(
        queryData,
        filterDataToSend,
        pagecount,
        PageNumber,
        templateData.templateSettingDTO.eF2,
        templateData.templateSettingDTO.reportType,
        commonFilter
      );
      listReport(val?.table);

      let TotalRecords = getCaseInSensitiveFieldValueFromObject("TotalRecords", val.table[0]) ?? 0;

      setTotalRecords(TotalRecords);
      console.log(val);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (filtercondition.length > 2 && editData == null) {
      fetchfilter();
      return;
    }
    recall();
  }, [PageNumber]);

  const listReport = async (
    tableData,
    rowWiseEdit1,
    rowWiseDelete1,
    rowWiseWhatsapp1,
    rowWisePrint1,
    combinedTotalValue
  ) => {
    ;
    try {
      let filteredData = tableData;

      const newData = filteredData.map((item, i) => {
        //;
        const dynamicProperties = Object.entries(item).reduce(
          (acc, [key, value]) => {
            acc[key.toLowerCase()] = value;
            return acc;
          },
          {}
        );


        const Trans1IdT1 = getCaseInSensitiveFieldValueFromObject("Trans1IdT1", item);
        const TransTypeT1 = getCaseInSensitiveFieldValueFromObject("TransTypeT1", item);
        const DBIdT1 = getCaseInSensitiveFieldValueFromObject("DBIdT1", item);
        const Id = getCaseInSensitiveFieldValueFromObject("Id", item);
        const StatusName = getCaseInSensitiveFieldValueFromObject("StatusName", item);
        const TotalBalanceQty = getCaseInSensitiveFieldValueFromObject("TotalBalanceQty", item);
        const TransId = getCaseInSensitiveFieldValueFromObject("TransId", item);
        const ProductCategory = getCaseInSensitiveFieldValueFromObject("ProductCategory", item);


        return {
          input: (
            <input type="checkbox" onChange={() => handleCheckboxChange(i)} />
          ),
          sno: i + 1,
          // ...rest,
          ...dynamicProperties,
          action: (
            <div className="tablelist-action-box">
              {(rowWiseEdit1 || rowWiseEdit) &&
                (parseInt(url.split("?")[1]) == 53 ? (
                  <i
                    className="fa-solid fa-pen-to-square TableEditIcon"
                    onClick={() => {
                      if (UserDetails && UserDetails.canModifyMaster) {
                        navigate(`/saleinvoice/${53}`, {
                          state: {
                            ConversionTransId: Trans1IdT1,
                            IsConversion: true,
                            transTypeT1: TransTypeT1,
                            ConvertType: 3,
                            DBIdT1: DBIdT1, // From Db1Id
                            TableId: Id,
                          },
                        });
                      } else {
                        Swal.fire({
                          icon: "warning",
                          title: "You have not permission to edit Master!",
                          text: "",
                          timer: 2000,
                          showConfirmButton: false,
                          timerProgressBar: true,
                          width: "250px",
                          customClass: {
                            title: "swal2-custom-title",    confirmButton: 'my-confirm-button',
    cancelButton: 'my-cancel-button' ,

                            popup: "swal2-custom-popup",
                            htmlContainer: "swal2-custom-text",
                            icon: "swal2-custom-icon",
                          },
                        });
                      }
                    }}
                  ></i>
                ) : (
                  <i
                    className="fa-regular fa-pen-to-square TableEditIcon"
                    onClick={() => {
                      if (UserDetails && UserDetails.canModifyMaster) {
                        editTemplateSetting(item);
                      } else {
                        Swal.fire({
                          icon: "warning",
                          title: "You have not permission to edit Master!",
                          text: "",
                          timer: 2000,
                          showConfirmButton: false,
                          timerProgressBar: true,
                          width: "250px",
                          customClass: {
                            title: "swal2-custom-title",    confirmButton: 'my-confirm-button',
    cancelButton: 'my-cancel-button' ,

                            popup: "swal2-custom-popup",
                            htmlContainer: "swal2-custom-text",
                            icon: "swal2-custom-icon",
                          },
                        });
                      }
                    }}
                  ></i>
                ))}
              {(rowWiseDelete1 || rowWiseDelete) && (
                <i
                  className="fa-regular fa-trash-can TableDelIcon"
                  onClick={() => {
                    if (UserDetails && UserDetails.canDelMaster) {
                      deleteTemplateSetting(item);
                    } else {
                      Swal.fire({
                        icon: "warning",
                        title: "You have not permission to delete Master!",
                        text: "",
                        timer: 2000,
                        showConfirmButton: false,
                        timerProgressBar: true,
                        width: "250px",
                        customClass: {
                          title: "swal2-custom-title",    confirmButton: 'my-confirm-button',
    cancelButton: 'my-cancel-button' ,

                          popup: "swal2-custom-popup",
                          htmlContainer: "swal2-custom-text",
                          icon: "swal2-custom-icon",
                        },
                      });
                    }
                  }}
                ></i>
              )}
              {(rowWiseWhatsapp1 || rowWiseWhatsapp) && (
                <i
                  className="fa-brands fa-square-whatsapp TableWhatsappcon"
                  onClick={() => handleShare(Id)}
                ></i>
              )}
              {(rowWisePrint1 || rowWisePrint) && (
                <i className="fa-solid fa-print TablePrint"></i>
              )}
              {ProductCategory != null &&
                parseInt(ProductCategory) === 1 && (
                  <Link to={`/LensMaster/${Id}`} state={{ item }}>
                    <i className="fa-solid fa-gear"></i>
                  </Link>
                )}
              {rowwiseArrowforNavigationtoAnotherPage && (
                <i
                  className="fa-solid fa-link TablePrint"
                  onClick={() => alert("navigation")}
                ></i>
              )}
              {rowwiseArrowforNavigationtoAnotherPage && (
                <i
                  className="fa-solid fa-link TablePrint"
                  onClick={() => alert("popup")}
                ></i>
              )}
              {/* {parseInt(url.split("?")[1]) == 53 && (
                <i
                  className="fa-solid fa-pen-to-square TableEditIcon"
                  onClick={() =>
                    navigate(`/saleinvoice/${53}`, {
                      state: {
                        ConversionTransId: item.Trans1IdT1 || item.trans1IdT1,
                        IsConversion: true,
                        transTypeT1: item.TransTypeT1 || item.transTypeT1,
                        ConvertType: 3,
                        DBIdT1: item.fromDbID, // From Db1Id
                      },
                    })
                  }
                ></i>
              )} */}
            </div>
          ),
        };
      });

      console.log(newData);
      setData1(newData);
      console.log(combinedTotalValue);

      const dynamicTotalValue = Array.isArray(
        combinedTotalValue || reportConfig
      )
        ? (combinedTotalValue || reportConfig).map((total) => {
          const columnName = total.columnName.toLowerCase() || "";
          const columnSum = newData.reduce((sum, row) => {
            const value = parseFloat(row[columnName]);
            return !isNaN(value) ? sum + value : sum;
          }, 0);
          return {
            accessor: total.columnName.toLowerCase(),
            columnShowTotalValue: total.columnShowTotalValue,
            total: columnSum,
            priority: parseInt(total.col1, 10) || 0,
          };
        })
        : [];

      const sortedDynamicTotalValue = dynamicTotalValue.sort(
        (a, b) => a.priority - b.priority
      );

      setTotalValue(sortedDynamicTotalValue);
      console.log("Calculated Totals", sortedDynamicTotalValue);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const [editData, setEditData] = useState(null);

  const editTemplateSetting = async (data) => {
    console.log(data);

    try {
      const reportAttachTo1 = url.split("?")[1];

      let data1;
      ;

      const d1RefId = getCaseInSensitiveFieldValueFromObject("d1RefId", data);
      const Id = getCaseInSensitiveFieldValueFromObject("Id", data);


      if (reportAttachTo1 == 2) {
        data1 = null;


        const itemData = await AccountApi.getAccountById(
          d1RefId || Id
        );
        setEditData(itemData.item1);
        setReportAttachTo(2);
      } else if (reportAttachTo1 == 4) {
        // data1 = `/ItemMaster?${data.id}`; // Adjust the path as needed
        data1 = null;
        const itemData = await ItemMasterApi.GetItemMasterById(
          Id
        );
        setEditData(itemData);
        setReportAttachTo(4);
      } else if (reportAttachTo1 == 1) {
        data1 = null;
        const itemData = await AccountGroup.GetAccountGroupById(
          Id
        );
        // console.log(data);
        setEditData(itemData);
        setReportAttachTo(1);
      } else if (reportAttachTo1 == 3) {
        // data1 = `/ItemGroupMaster?${data.id}`;
        data1 = null;
        const itemData = await ItemGroup.GetItemGroupByD2Id(Id);
        // console.log(data);
        setEditData(itemData);
        setReportAttachTo(3);
        // toggleSlider(true);
      } else if (reportAttachTo1 == 8) {
        data1 = null;
        const itemData = await UnitMasterApi.getUnitMasterById(Id);
        // console.log(data);
        setEditData(itemData);
        setReportAttachTo(8);
        setLoading(false);
      } else if (reportAttachTo1 == 45) {
        data1 = null;
        const itemData = await Agent.GetAgentById(Id);
        // console.log(data);
        setEditData(itemData);
        setReportAttachTo(8);
        setLoading(false);
      } else if (reportAttachTo1 == 34) {
        data1 = null;
        const itemData = await BillTypeApi.GetBillTypeById(Id);
        // console.log(data);
        setEditData(itemData);
        setReportAttachTo(34);
        setLoading(false);
      }
      else if (reportAttachTo1 == 69) {
        data1 = null;
        const itemData = await Station.getStationById(Id);
        // console.log(data);
        setEditData(itemData);
        setReportAttachTo(69);
        setLoading(false);
      }
      else if (reportAttachTo1 == 82) {
        data1 = null;
        const itemData = await AccountCategory.getAccountCategoryById(Id);
        // console.log(data);
        setEditData(itemData);
        setReportAttachTo(82);
        setLoading(false);
      }
      else if (reportAttachTo1 == 84) {
        data1 = null;
        const itemData = await StateInfo.GetAllState(Id);
        // console.log(data);
        setEditData(itemData);
        setReportAttachTo(84);
        setLoading(false);
      }

      if (data1) {
        navigate(data1); // Redirect to the appropriate page
        console.log("Navigating to:", data1);
      }

      setMasterId(data);
      await toggleSlider();
      setSliderOpen(true);
    } catch (error) {
      console.error("Error editing data:", error);
    }
  };

  const [getMasterType, setGetMasterType] = useState(null);
  const [getdeleteId, setDeleteId] = useState(null);

  const [isSliderOpen, setSliderOpen] = useState(false);
  const loaderstate = isSliderOpen;
  const toggleSlider = async () => {

    console.log(editData);
    await setSliderOpen(!loaderstate);
  };


  const deleteTemplateSetting = (item) => {
    //;
    const url = window.location.href;
    const reportAttachTo = url.split("?")[1];
    setAlertBoxDelete(true);
    setGetMasterType(reportAttachTo);

    const itemId = getCaseInSensitiveFieldValueFromObject("Id", item);
    setDeleteId(itemId);
  };

  const DeleteTemplateConfirm = async () => {
    setLoading(true);
    //;
    try {
      const val = await TemplateSettingApi.deleteTemplateSetting(
        getMasterType,
        getdeleteId
      );
      console.log(val);

      ;
      if (Boolean(val.isSuccess) === true) {
        setAlertBoxDelete(false);
        setGetMasterType(null);
        setDeleteId(null);
        setLoading(false);
        fetchDataTemp();
      } else if (val.statusCode == 409) {
        setLoading(false);
        alert(val.errorMessages);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error deleting data:", error);
    } finally {
      setLoading(false);
      fetchDataTemp();
    }
  };

  const [selectedData, setSelectedData] = useState([]);

  const handleCheckboxChange = (id) => {
    const selectedItem = data1.find((item) => {

      const itemId = getCaseInSensitiveFieldValueFromObject("Id", item);

      return itemId === id;
    });

    if (selectedItem) {
      setSelectedData((prevSelectedData) => {
        const isSelected = prevSelectedData.some((item) => {
          const itemId = getCaseInSensitiveFieldValueFromObject("Id", item);
          return itemId === id;
        });

        if (isSelected) {
          return prevSelectedData.filter((item) => {

            const itemId = getCaseInSensitiveFieldValueFromObject("Id", item);
            return itemId !== id;
          });
        } else {
          return [...prevSelectedData, selectedItem];
        }
      });
    }
    console.log(selectedData);
  };

  const handleShare = (id) => {

    const listToSend = data1.find((item) => {

      const itemId = getCaseInSensitiveFieldValueFromObject("Id", item);
      return itemId === id;
    });

    const whatsappURL = `https://api.whatsapp.com/send?text=${encodeURIComponent(
      listToSend
    )}`;
    window.location.href = whatsappURL;
  };

  const [createData, setCreateData] = useState(null);
  console.log(createData);


  useEffect(() => {
    createTemplateSetting();
  }, [templateData]);

  const createTemplateSetting = async () => {
    ;
    try {
      if (templateData) {
        const pageLink = templateData.templateSettingDTO.pageLink;
        if (pageLink && pageLink !== "/") {
          const CreateUrl = `${pageLink}`;
          setCreateData(CreateUrl);
        } else {
          setCreateData("");
        }
      }
    } catch (error) {
      console.error("Error creating template setting:", error);
    }
  };

  const fetchData1 = async () => {
    try {
      const url = window.location.href;
      const reportAttachTo = url.split("?")[1];
      const response = await TemplateSettingApi.getAllMasterType();
      if (response && Array.isArray(response)) {
        const matchingItem = response.find((item) => item.id == reportAttachTo);

        if (matchingItem) {
          setHeading(matchingItem.name);
        } else {
          console.error(
            "No matching master type found for reportAttachTo:",
            reportAttachTo
          );
        }
      } else {
        console.error("Error:", response.errorMessages);
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  useEffect(() => {
    fetchData1();
  }, [reportAttachTo]);

  const convertDataToAOA = async () => {
    if (selectedData.length !== 0) {
      if (!selectedData.length) {
        return [];
      }
      const fields = Object.keys(props.selectedData[0]);
      const filteredFields = fields.slice(2, -1);

      const sortedData = props.selectedData.sort((a, b) => a["sno"] - b["sno"]);
      const result = [
        filteredFields,
        ...sortedData.map((row) => filteredFields.map((field) => row[field])),
      ];
      return result;
    } else {
      try {
        setLoading(true);

        var filter = filtercondition;

        const ALL_RECORDS = 999999;
        const response = await TemplateSettingApi.getDatasetExecuteQueryFilter(
          queryData,
          filter,
          ALL_RECORDS,
          PageNumber,
          templateData.templateSettingDTO.eF2,
          templateData.templateSettingDTO.reportType,
          commonFilter
        );
        console.log(response);
        const newData = response.table.map((item, i) => {
          return Object.entries(item).reduce((acc, [key, value]) => {
            acc[key.toLowerCase()] = value;
            return acc;
          }, {});
        });

        const fields = Object.keys(newData[0]);
        // const filteredFields = fields.slice(2, -1);

        return [
          fields,
          ...newData.map((row) => fields.map((field) => row[field])),
        ];
      } catch (error) {
        console.error("Error executing query:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleDataExport = async () => {
    ;
    const Data = await convertDataToAOA();
    const ws = XLSX.utils.aoa_to_sheet(Data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");
    const filename = `table_data_${Date.now()}.xlsx`;
    XLSX.writeFile(wb, filename);
  };

  // const componentMap = {
  //   1: React.lazy(() =>
  //     import("../../Master/AccountMaster/AccountGroupMaster")
  //   ),
  //   2: React.lazy(() => import("../../Master/AccountMaster/AccountMaster")),
  //   3: React.lazy(() => import("../../Master/InvertoryMaster/ItemGroupMaster")),
  //   4: React.lazy(() => import("../../Master/InvertoryMaster/ItemMaster")),
  //   8: React.lazy(() => import("../../Master/InvertoryMaster/UnitMaster")),
  //   45: React.lazy(() => import("../../Master/AccountMaster/AgentMaster")),
  // };

  // const MasterComponent = componentMap[reportAttachTo];

  const handleNameChange = () => {

  }

  return (
    <div className="">
      <PageTabs
        locationTab={createData}
        modelOpen={true}
        setSliderCallBack={setSliderOpen}
      />
      <div className="nav-1">
        <div className="panel-heading">
          <h2 className="panel-title">{heading} List</h2>
          <ReportTableButton
            createTemplateSetting={createTemplateSetting}
            createData={createData}
            filterData={filterData}
            columns={columns}
            data={data1}
            handleDataExport={handleDataExport}
            selectedData={selectedData}
            printButton={printButton}
            excelButton={excelButton}
            shareButton={shareButton}
          />
        </div>
        <MasterReportDataTable
          debouncedFunction={handleKeyDown}
          PageNumber={PageNumber}
          setPageNumber={setPageNumber}
          pagecount={pagecount}
          fetchData={fetchData}
          filterData={filterData}
          columns={columns}
          totalValue={totalValue}
          data={data1}
          searchAnyText={searchAnyText}
          searchByDate={searchByDate}
          searchByColumn={searchByColumn}
          columnShowTotalValue={columnShowTotalValue}
          calculatedTotals={calculatedTotals}
          tableData={tableData}
          universalSearch={universalSearch}
          handleKeyDownUniversal={handleKeyDownUniversal}
          setUniversalSearch={setUniversalSearch}
          customStartDate={customStartDate}
          customEndDate={customEndDate}
          handleCustomDateChange={handleCustomDateChange}
          fetchDataTemp={fetchDataTemp}
          firmNameSelect={firmNameSelect}
          transactionType={transactionType}
          billSeries={billSeries}
          useDoubleClick={useDoubleClick}
          totalRecords={totalRecords}
          navigateTo={navigateTo}
          changeDoubleClickFilter={changeDoubleClickFilter}
          setReportAttachTo={setReportAttachTo}
          setDateFilterCustom={setDateFilterCustom}
          templateData={templateData}
          showSetting={true}
          templateSettingDTOId={templateSettingDTOId}
          handleAlphabetSelect={handleAlphabetSelect}
          dbColumnAndReportColumnNameMap={dbColumnAndReportColumnNameMap}
          setSelectedOptions2={setSelectedOptions2}
          selectedOptions2={selectedOptions2}
          handleNameChange={handleNameChange}
          rowWiseEdit1={templateData?.templateSettingDTO?.rowWise_Edit}
          rowWiseDelete1={templateData?.templateSettingDTO?.rowWise_Delete}
          rowWiseWhatsapp1={templateData?.templateSettingDTO?.rowWise_Whatsapp}
          rowWisePrint1={templateData?.templateSettingDTO?.rowWise_Print}
          queryData={queryData}
          combinedTotalValue={templateData?.templateSettingReportConfigList}
          ef1={templateData?.templateSettingDTO?.eF1}
          ef2={templateData?.templateSettingDTO?.eF2}
          reportType={templateData?.templateSettingDTO?.reportType}
          commonFilter={commonFilter}
          setCommonFilter={setCommonFilter}
          dateRangeToShow={dateRangeToShow}
          setDateRangeToShow={setDateRangeToShow}
        />
      </div>
      {/******************************* Unit Master Modal*************************/}

      {isSliderOpen && (
        <div className={`slider-container100 ${isSliderOpen ? "open" : ""}`}>
          {/* <div style={{ padding: "15px" }}>
                <MasterReport editData={editData} modelOpen={true} setSliderCallBack={setSliderOpen} fetchData={fetchData} 
                reportAttachTo={reportAttachTo == 2 ? AccountMaster1 : (reportAttachTo == 4 ? ItemMaster : null)}
                />
                </div> */}
          {reportAttachTo == 2 && (
            <div style={{ padding: "15px" }}>
              <AccountMaster1
                editData={editData}
                getdeleteId={getdeleteId}
                modelOpen={true}
                setSliderCallBack={setSliderOpen}
                fetchData={fetchData}
                fetchDataTemp={fetchDataTemp}
                data={data1}
                masterId={masterId}
              />
            </div>
          )}
          {reportAttachTo == 4 && (
            <div style={{ padding: "15px" }}>
              <ItemMaster
                data={editData}
                getdeleteId={getdeleteId}
                modelOpen={true}
                setSliderCallBack={setSliderOpen}
                fetchData={fetchData} //data={data1}
                fetchDataTemp={fetchDataTemp}
                masterId={masterId}
              />
            </div>
          )}
          {reportAttachTo == 1 && (
            <div style={{ padding: "15px" }}>
              <AccountGroupMaster
                data={editData}
                getdeleteId={getdeleteId}
                modelOpen={true}
                setSliderCallBack={setSliderOpen}
                fetchData={fetchData}
                fetchDataTemp={fetchDataTemp}
                // data={data1}
                masterId={masterId}
              />
            </div>
          )}
          {reportAttachTo == 3 && (
            <div style={{ padding: "15px" }}>
              <ItemGroupMaster
                data={editData}
                getdeleteId={getdeleteId}
                modelOpen={true}
                setSliderCallBack={setSliderOpen}
                fetchData={fetchData}
                fetchDataTemp={fetchDataTemp}
                // data={data1}
                masterId={masterId}
              />
            </div>
          )}
          {reportAttachTo == 8 && (
            <div style={{ padding: "15px" }}>
              <UnitMaster
                editData={editData}
                getdeleteId={getdeleteId}
                modelOpen={true}
                setSliderCallBack={setSliderOpen}
                fetchData={fetchData}
                fetchDataTemp={fetchDataTemp}
                data={data1}
                masterId={masterId}
              />
            </div>
          )}
          {reportAttachTo == 45 && (
            <div style={{ padding: "15px" }}>
              <AgentMaster
                editData={editData}
                getdeleteId={getdeleteId}
                modelOpen={true}
                setSliderCallBack={setSliderOpen}
                fetchData={fetchData}
                fetchDataTemp={fetchDataTemp}
                data={data1}
                masterId={masterId}
              />
            </div>
          )}
          {reportAttachTo == 34 && (
            <div style={{ padding: "15px" }}>
              <BillType
                editData={editData}
                getdeleteId={getdeleteId}
                modelOpen={true}
                setSliderCallBack={setSliderOpen}
                fetchData={fetchData}
                fetchDataTemp={fetchDataTemp}
                data={data1}
                masterId={masterId}
              />
            </div>
          )}
          {reportAttachTo == 69 && (
            <div style={{ padding: "15px" }}>
              <StationMaster
                editData={editData}
                getdeleteId={getdeleteId}
                modelOpen={true}
                setSliderCallBack={setSliderOpen}
                fetchData={fetchData}
                fetchDataTemp={fetchDataTemp}
                data={data1}
                masterId={masterId}
              />
            </div>
          )}
          {reportAttachTo == 82 && (
            <div style={{ padding: "15px" }}>
              <AccountCategoryMaster
                editData={editData}
                getdeleteId={getdeleteId}
                modelOpen={true}
                setSliderCallBack={setSliderOpen}
                fetchData={fetchData}
                fetchDataTemp={fetchDataTemp}
                data={data1}
                masterId={masterId}
              />
            </div>

          )}
          {reportAttachTo == 84 && (
            <div style={{ padding: "15px" }}>
              <TransportMaster
                editData={editData}
                getdeleteId={getdeleteId}
                modelOpen={true}
                setSliderCallBack={setSliderOpen}
                fetchData={fetchData}
                fetchDataTemp={fetchDataTemp}
                data={data1}
                masterId={masterId}
              />
            </div>

          )}

          {/* {MasterComponent && (
            <Suspense fallback={<div>Loading...</div>}>
              <div style={{ padding: "15px" }}>
                <MasterComponent
                  data={editData}
                  editData={editData}
                  getdeleteId={getdeleteId}
                  modelOpen={true}
                  setSliderCallBack={setSliderOpen}
                  fetchData={fetchData}
                  fetchDataTemp={fetchDataTemp}
                  // data={data1}
                  masterId={masterId}
                />
              </div>
            </Suspense>
          )} */}
        </div>
      )}

      {/* ********************************************** Mobile View ***************************** */}
      <div className="wrapper">
        <div className="container">
          <div className=" content-row-1">
            <div className="class_control">
              <div className="balance-1">
                <div className="p-11">
                  <p className="balance-p1">
                    <i className="fa-solid fa-arrow-up icon_3"></i>Sale
                  </p>
                </div>
                <div className="p-12">
                  <p className="balance-p2">
                    <i className="fa-solid fa-indian-rupee-sign rs_sign"></i>100
                  </p>
                </div>
              </div>
              <div className="balance-1">
                <div className="p-11">
                  <p className="balance-p1">
                    {" "}
                    <i className="fa-solid fa-clipboard icon_3"></i> Total
                  </p>
                </div>
                <div className="p-12">
                  <p className="balance-p2">
                    <i className="fa-solid fa-indian-rupee-sign rs_sign"></i>200
                  </p>
                </div>
              </div>
              <div className="balance-1">
                <div className="p-11">
                  <p className="balance-p1">
                    <i className="fa-solid fa-arrow-down icon_3"></i>Return
                  </p>
                </div>
                <div className="p-12">
                  <p className="balance-p2">
                    <i className="fa-solid fa-indian-rupee-sign rs_sign"></i>100
                  </p>
                </div>
              </div>
            </div>
            <div className="class_control_2">
              <div className="parti_1">
                <div className="sub_parti_1">
                  <p className="parti-p-1">Parties</p>
                </div>
              </div>
              <div className="parti_1">
                <div className="sub_parti_1">
                  <p className="parti-p-1">Trasaction</p>
                </div>
              </div>
              <div className="parti_1">
                <div className="sub_parti_1">
                  <p className="parti-p-1">Items</p>
                </div>
              </div>
            </div>
            <div className="class_control_4">
              <div className="col_ms_1">
                <p className="p_13">Recent History</p>
                <div className="con_input_1">
                  <input
                    type="text"
                    className="input_box_2"
                    placeholder="Search..."
                  />
                </div>
              </div>

              <div className="col_sm_11">
                <div className="col_sm_21">
                  <div className="col_sm_12">
                    <div className="con_name_1">
                      <p className="con_p_3">Akash kumar</p>
                    </div>
                    <div className="con_name_1">
                      <p className="con_p_1">Sale</p>
                    </div>
                    <div className="con_name_1">
                      <p className="con_p_2">Total</p>
                    </div>
                    <div className="con_name_1">
                      <p className="con_p_4">
                        <i className="fa-solid fa-indian-rupee-sign rs_sign1"></i>
                        1000
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col_sm_13">
                  <div className="col_sm_12">
                    <div className="con_total_3">
                      <p className="con_p_3">Balance</p>
                    </div>
                    <div className="con_total_3">
                      <p className="con_price_p">
                        <i className="fa-solid fa-indian-rupee-sign rs_sign1"></i>
                        1000
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col_sm_14">
                  <div className="col_sm_12">
                    <div className="con_sale_2">
                      <p className="con_p_3">Date</p>
                    </div>
                    <div className="con_sale_2">
                      <p>#1</p>
                    </div>
                    <div className="con_name_1 con_name_7">
                      <i className="fa-solid fa-print"></i>
                      <i className="fa-solid fa-share"></i>
                      <i className="fa-solid fa-ellipsis-vertical"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <ListSaveButton />
            </div>
          </div>
        </div>
      </div>
      {/* ***************************** */}
      {alertBoxDelete && (
        <AlertBox
          HeadingTop="DELETE"
          Heading="Are You sure you want to delete this"
          OpenAlertBox={OpenAlertBoxDelete}
          onYesClick={DeleteTemplateConfirm}
        />
      )}

      {loading && <Loader />}
    </div>
  );
}
export default MasterListReport;
